<template>
  <div class="box">
    <header>
      <div class="logo">
        <img src="../assets/logo.png" alt="" />
        <span class="logoname">KOPERASI SIMPAN PINJAM COINKU INDONESIA</span>
      </div>
      <nav>
        <a href="#product">Home</a>
        <a href="#Process">Getting a Loan</a>
        <a href="#Advantages">Product concept</a>
        <a href="#Why">Borrowing steps</a>
        <a href="#Privacy">User evaluation</a>

      </nav>
    </header>
    <div class="box-1" id="product">

      <div class="name">
        KOPERASI SIMPAN PINJAM COINKU INDONESIA
      </div>
      <div class="logomsg">
        Koperasi yang hanya melayani anggota, terutama menyediakan layanan simpan pinjam kepada anggota, membantu anggota mengelola dana mereka dengan lebih baik dan memperoleh keuntungan. </div>
    </div>
    <div class="box-3" id="Process">
      <h2 class="title">Mendapatkan pinjaman sangat mudah</h2>
      <div class="ltit">
        KOPERASI SIMPAN PINJAM COINKU INDONESIA membantu anggota mendapatkan pinjaman dengan mudah
      </div>
      <div class="content">
        <div class="item">
          <img src="../assets/step1.png" alt="">
          <h4>Keuntungan satu:</h4>
          <div class="label">Proses persetujuan pinjaman mudah dan cepat</div>
          <div class="value">KOPERASI SIMPAN PINJAM COINKU INDONESIA meluncurkan APP pinjaman keuangan untuk membantu pengguna dengan mudah mengajukan permohonan pinjaman secara online</div>
        </div>
        <div class="item">
          <img src="../assets/step2.png" alt="">
          <h4>Keuntungan dua:</h4>
          <div class="label">Aman dan pribadi</div>
          <div class="value">Short Description: Our app uses state-of-the-art encryption technology to protect user data, ensuring</div>
        </div>
        <div class="item">
          <img src="../assets/step3.png" alt="">
          <h4>Keuntungan ketiga:</h4>
          <div class="label">Tim profesional</div>
          <div class="value">KOPERASI SIMPAN PINJAM COINKU INDONESIA memiliki tim profesional berkualifikasi tinggi yang mencakup berbagai bidang seperti komputer, keuangan, dan hukum, memberikan Anda layanan terpadu lengkap.</div>
        </div>
      </div>
    </div>
    <div class="box-4" id="Advantages">
      <h2 class="title">Filosofi perusahaan</h2>
      <div class="content">
        <div class="item">
          <div class="label">Kepemilikan bersama, kemakmuran bersama</div>
          <div class="value">Di KOPERASI SIMPAN PINJAM COINKU INDONESIA (COINKU), kami sangat yakin bahwa kepemilikan bersama adalah kunci untuk mencapai kesejahteraan bersama. COINKU bukan sekedar koperasi keuangan, melainkan komunitas yang dimiliki dan dikelola bersama oleh para anggotanya.</div>
        </div>
        <div class="item flex-box">
          <img src="../assets/box1.png" alt="">
          <!-- <div class="label">Inklusi keuangan, melayani masyarakat</div> -->
          <div>
            <div class="label">Inklusi keuangan, melayani masyarakat</div>
            <div class="value">
              Kami memahami pentingnya inklusi keuangan bagi masyarakat. Oleh karena itu, COINKU berkomitmen untuk memberikan kesempatan layanan keuangan yang setara kepada masyarakat Indonesia. Tidak peduli dari kelas sosial mana Anda berasal, tidak peduli seberapa besar atau kecil kebutuhan keuangan Anda, kami menyediakan layanan simpan pinjam untuk membantu Anda mencapai tujuan keuangan dan berinvestasi untuk masa depan Anda.
            </div>
          </div>
        </div>
        <div class="item">
          <img src="../assets/box2.png" alt="">
          <div class="label">Inovasi dan tanggung jawab memimpin masa depan</div>
          <div class="value">COINKU singkatan dari inovasi dan tanggung jawab. Kami selalu mencari cara baru untuk menyediakan layanan keuangan yang lebih nyaman. Kami secara aktif mengadopsi teknologi terkini untuk memastikan bahwa anggota dapat menikmati pengalaman keuangan yang efisien dan aman.</div>
        </div>
      </div>
    </div>
    <div class="box-5" id="Why">
      <h2 class="title">Langkah-langkah penggunaan:</h2>
      <div class="content">
        <div class="item">
          <img src="../assets/easy1.png" alt="">
          <div>
            <div class="value">
              1. Daftar sebagai anggota: Unduh produk yang dikembangkan oleh KOPERASI SIMPAN PINJAM COINKU INDONESIA, dan gunakan nomor ponsel Anda untuk mendaftar menjadi anggota; <br> <br>
              2. Isi informasi: Isi informasi secara online dan kirimkan lamaran
            </div>
          </div>
        </div>
        <div class="item">

          <div>
            <!-- <div class="label">
              Getting a loan is easy!
            </div> -->
            <div class="value">
              3. Menunggu persetujuan: Menunggu evaluasi skor kredit untuk memastikan batas pinjaman, jangka waktu dan tingkat bunga. KOPERASI SIMPAN PINJAM COINKU INDONESIA tidak menjamin setiap anggota dapat memperoleh pinjaman, silahkan mengacu pada hasil persetujuan sebenarnya. </div>
          </div>
          <img src="../assets/easy2.png" alt="">
        </div>
      </div>
    </div>
    <div class="box-6" id="Privacy">
      <div class="content">
        <div class="title">Komentar anggota:</div>
        <div class="content">COINKU selalu menjadi mitra keuangan saya yang paling dapat diandalkan. Rekening tabungan mereka tidak hanya memiliki suku bunga yang sangat baik, tetapi mereka juga memberikan layanan pinjaman yang nyaman dan cepat. Yang terpenting, mereka memahami kebutuhan keuangan saya dan selalu memberikan solusi terbaik untuk saya. saran .</div>
      </div>
    </div>

    <footer class="bottom">
      <p>
        <img class="email" src="../assets/email.png" alt="" />
        kspcoinkuindonesia@outlook.com
      </p>
      <p>
        <img class="address" src="../assets/address.png" alt="" />JL. KAPTEN PIERE TENDEAN LT. 5 NO. 27 A
      </p>
    </footer>
  </div>
</template>

<script>
import privacy from "@/components/privacy";

export default {
  name: "App",
  components: { privacy },
  data() {
    return {
      isMore: false,
      menuIndex: 0,
      screenWidth: document.body.clientWidth,
      showMenu: false,
      showPrivasi: false,
      show: false,
    };
  },
  mounted() {
    if (this.$route.query.partner == 1) {
      this.$nextTick(() => {
        setTimeout(() => {
          document.getElementById("partner").scrollIntoView();
        }, 100);
      });
    }
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
  },
  methods: {
    choiceMenu(index) {
      this.menuIndex = index;
      setTimeout(() => {
        this.showMenu = false;
      }, 100);
      switch (index) {
        case 0:
          document.getElementById("home").scrollIntoView();
          break;
        case 1:
          document.getElementById("step").scrollIntoView();
          break;
        case 2:
          document.getElementById("product").scrollIntoView();
          break;
        case 3:
          document.getElementById("user").scrollIntoView();
          break;
        case 4:
          document.getElementById("about").scrollIntoView();
          break;
        case 5:
          document.getElementById("privacy").scrollIntoView();
          break;
        case 6:
          document.getElementById("footer").scrollIntoView();
          break;
        default:
          break;
      }
    },
    menuClick() {
      this.showMenu = !this.showMenu;
    },
    toPrivacy() {
      this.$router.push({ path: "/privacy" });
    },
  },
};
</script>
<style lang="less">
@import url("@/style/m_index.less") only screen and (max-width: 750px);
@import url("@/style/pc_index.less") only screen and (min-width: 750px);
</style>
<style scoped>
.privasi {
  margin-top: 234px;
  padding: 0;
}
</style>
